"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationModalMetadataForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _constants = require("@/util/constants");
var _TeamsIntegrationModalMetadataFormModule = _interopRequireDefault(require("./TeamsIntegrationModalMetadataForm.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TeamsIntegrationModalMetadataForm = exports.TeamsIntegrationModalMetadataForm = function TeamsIntegrationModalMetadataForm(_ref) {
  var _metadata$length;
  var handleFileCategoryChange = _ref.handleFileCategoryChange,
    handleMetadataChange = _ref.handleMetadataChange,
    metadata = _ref.metadata,
    fileCategory = _ref.fileCategory;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationModalMetadataFormModule["default"].formDetails
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _TeamsIntegrationModalMetadataFormModule["default"].title
  }, "Details"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationModalMetadataFormModule["default"].flexContainer
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _TeamsIntegrationModalMetadataFormModule["default"].description
  }, "Provide the file details."), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: _TeamsIntegrationModalMetadataFormModule["default"].requiredIndicator
  }, "*"), "Indicates required")), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationModalMetadataFormModule["default"].formFields
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationModalMetadataFormModule["default"].fieldContainer
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: _TeamsIntegrationModalMetadataFormModule["default"].requiredIndicator
  }, "*"), "File category"), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    color: "success",
    select: true,
    label: "Select",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    value: fileCategory,
    size: "small",
    inputProps: {
      "data-testid": "categorySelector"
    },
    onChange: function onChange(e) {
      handleFileCategoryChange(e.target.value);
    }
  }, _constants.CATEGORIES.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: option.value,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationModalMetadataFormModule["default"].fieldContainer
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Metadata"), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    color: "success",
    label: "Type",
    fullWidth: true,
    multiline: true,
    rows: 4,
    value: metadata,
    margin: "normal",
    variant: "outlined",
    onChange: function onChange(e) {
      handleMetadataChange(e.target.value);
    },
    inputProps: {
      "data-testid": "metadataField",
      maxLength: _constants.MAX_METADATA_LENGTH
    },
    placeholder: "Metadata improves AI search by adding context with keywords and descriptions, making search results more relevant and responses better."
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: _TeamsIntegrationModalMetadataFormModule["default"].textCounterContainer
  }, (_metadata$length = metadata === null || metadata === void 0 ? void 0 : metadata.length) !== null && _metadata$length !== void 0 ? _metadata$length : 0, " / ", _constants.MAX_METADATA_LENGTH))));
};